import React from 'react';
import { Text } from '@adc/parallax-component-library';
import styled from 'styled-components';
const BtnWrapper = styled.button `
  border: none;
  background: none;
  padding: 0;
  margin: auto;
  display: flex;
  justify-content: 'center';
  cursor: pointer;
`;
const Link = ({ children, onPress, disabled, testID, IconElement, textColor = '$interactive.tertiary.enabled.onColor', fontSize = '$bodyBase.strong', fontWeight = '$bodyBase.strong', padding = '$0', ...rest }) => {
    return (React.createElement(BtnWrapper, { id: testID, onClick: onPress, disabled: disabled, ...rest },
        IconElement && (React.createElement(IconElement, { color: "$interactive.tertiary.enabled.onColor", testID: `${testID}-icon` })),
        React.createElement(Text, { marginLeft: IconElement ? '$2' : '$0', padding: padding, fontSize: fontSize, fontWeight: fontWeight, color: disabled ? '$interactive.tertiary.disabled.onColor' : textColor, testID: `${testID}-text` }, children)));
};
export { Link };
